import { AbsoluteCenter, Button, Heading, Text, VStack } from "@chakra-ui/react";
import { Link } from "react-router-dom";
import { PageContent, PageHeader, PageLayout } from "@/components/page";

const NotFound = () => {
  return (
    <PageLayout>
      <PageHeader backLink="/">Page Not Found</PageHeader>
      <PageContent h="calc(100vh - 3rem)">
        <AbsoluteCenter>
          <VStack gap={6} textAlign="center">
            <Heading
              as="h1"
              size="7xl"
              bgGradient="to-b"
              gradientFrom="red.300"
              gradientTo="blue.300"
              bgClip="text"
            >
              404
            </Heading>
            <Text fontSize="xl" mt={3} mb={2}>
              The page you're looking for can not be found.
            </Text>
            <Text mb={6}>
              You may have mistyped the URL, or the page may have moved.
            </Text>
            <Link to="/">
              <Button
                colorPalette="blue"
                variant="solid"
              >
                Go to Home
              </Button>
            </Link>
          </VStack>
        </AbsoluteCenter>
      </PageContent>
    </PageLayout>
  );
};

export default NotFound;
